import get from 'lodash/get';
import PropTypes from 'prop-types';
import {Fragment,useState} from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Grid from "@mui/material/Grid";
import ListIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import './CustomCard.scss';


const getWrapperStyles = ({color, noTopBorder}) => ({
  background: '#fff',
});

const CardMenu = props => {
  const [anchorEl, setAnchorEl] = useState(null);
  const menuIsOpen = !!anchorEl;
  return (
    <>
      <Button
        id='positioned-button'
        aria-haspopup='true'
        aria-controls={menuIsOpen ? 'positioned-menu' : undefined}
        aria-expanded={menuIsOpen ? 'true' : undefined}
        onClick={e => setAnchorEl(e.currentTarget)}
      >
        <ListIcon />
      </Button>
      <Menu
        id='positioned-menu'
        aria-labelledby='positioned-button'
        anchorEl={anchorEl}
        open={menuIsOpen}
        onClose={() => setAnchorEl(null)}
        disableScrollLock={true}
      >
        {(props.menuItems || []).map((m, i) =>
          <Box key={'menuItem-' + i}>
            <MenuItem
              onClick={m.onClick}
              style={{minWidth: '150px'}}
            >
              {
                m.Icon && props.noIcon !== true
                ? <m.Icon
                  style={{marginRight: '0.25em', fontSize: '0.6em'}}
                />
                : null
              }
              {m.children}
            </MenuItem>
            {i !== (props.menuItems || []).length - 1 ? <Divider /> : null}
          </Box>
        )}
      </Menu>
    </>
  );
};

export const CardListItem = props => (
  <>
    {
      !props.text && !props.children
        ? null
        : <Grid container
            direction='row'
            style={{color: 'rgba(0,0,0,0.55)'}}
            alignItems='center'
          >
            {
              props.noIcon !== true
              && 
              <Grid item xs={1} display="flex" alignItems="center">
                {props.Icon ? <props.Icon style={{width: '20px', height: '20px'}} /> : null}
              </Grid>
            }
            <Grid item xs={11} display="flex" alignItems="center">
                {
                    props.text
                        ? <Typography variant='body2' width="100%">
                            {props.text}
                        </Typography>
                        : <>{props.children}</>
                }
            </Grid>
          </Grid>
    }
  </>


);

const CustomCard = props => {
  const ButtonOne = get(props, 'buttons[0]') || null;
  const ButtonTwo = get(props, 'buttons[1]') || null;
  return (
    <Box
      className='custom-card'
      style={getWrapperStyles({
        color: props.color, 
        noTopBorder: props.noTopBorder,
      })}
    >
      <Box
        className='custom-card__container'
        onClick={props?.onClick || null}
      >
        <Stack direction='row' justifyContent='space-between'>
          {
            props.title
            ? <Stack justifyContent='center'>
              <Typography
                variant='h4'
                style={{textOverflow: 'ellipsis'}}
              >
                {props.title}
              </Typography>
            </Stack>
            : null
          }
          {
            props.menuItems && props.menuItems.length
            ? <CardMenu menuItems={props.menuItems} />
            : <></>
          }
        </Stack>
        <Stack spacing={1}>
          {(props.listItems || []).map((li, i) =>
            <CardListItem key={'CardListItem-' + i} {...li} />
          )}
        </Stack>
        {props.children
          ? props.children
          : null
        }
      </Box>
      {
        props.buttons && props.buttons.length
        ? <Stack className='custom-card__button-container' direction='row' spacing={1.25} justifyContent={'space-between'}>
          {props.buttons[0]
            ? <Box className="custom-card__button-box">
              {props.passButtonChildren
                ? ButtonOne
                : <Button
                  fullWidth
                  style={{borderRadius: '0px'}}
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    // props?.buttons?.[0]?.onClick();
                  }}
                  disabled={props.buttons[0].disabled}
                >
                  {props.buttons[0].children}
                </Button>
              }
            </Box>
            : null
          }
          {props.buttons[1]
            ? <Box className="custom-card__button-box">
              {props.passButtonChildren
                ? ButtonTwo
                : <Button
                  fullWidth
                  style={{borderRadius: '0px'}}
                  onClick={e => {
                    e.stopPropagation();
                    // props?.buttons?.[1]?.onClick();
                  }}
                  disabled={!!props.buttons[1].disabled}
                >
                  {props.buttons[1].children}
                </Button>
              }
            </Box>
            : null
          }
        </Stack>
        : null
      }
    </Box>
  );
};

CustomCard.defaultProps = {
  color: 'rgba(0,0,0,0.2)',
  noTopBorder: false,
};

CustomCard.propTypes = {
  title: PropTypes.string,
  color: PropTypes.string,
  noTopBorder: PropTypes.bool,
  onClick: PropTypes.func,
};

export default CustomCard;
